import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class QuotesAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getById(id, router) {
    const url = `/api/quotes/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getByUserId(id, router) {
    const url = `/api/quotes/user/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getDefault(router) {
    const url = `/api/quotes/default`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(potentialStudentId, params) {
    const url = `/api/quotes/create/${potentialStudentId}`;
    return this.CommonAPIService.newFileCall(url, params);
  }

  update(id, params) {
    const url = `/api/quotes/${id}`;
    return this.CommonAPIService.newFileCall(url, params);
  }

}
export default QuotesAPIService;
